var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 692.613,
    height: 733.777,
    viewBox: "0 0 692.613 733.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 271.093,
    transform: "translate(1034.73 903.003) rotate(-30)",
    fill: "#3ba1ba"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -603.042,
    y: -410,
    width: 1938,
    height: 1099,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 57.613,
    y: 0,
    width: 617,
    height: 617,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 1.671,
    y: 481.778,
    width: 337.017,
    height: 107.294,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-166.387 -404)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-427.655)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 594.04, 404)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1081,
    transform: "translate(-594.04 -404)",
    fill: "#7fdbf2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 166.39, 404)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 299.5,
    r: 299.5,
    transform: "translate(66.61 6)",
    fill: "#bef2ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2464.796 3530.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2155.927-2945.7v29.762l-29.762-29.762Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2185.689-2915.933h29.762v29.762Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2215.452-2945.7h29.762v29.762Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2245.214-2945.7h29.763v29.762Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2274.977-2945.7h29.762v29.762Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2185.689-2886.17l-29.762-29.762h29.762Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2215.452-2886.17l-29.763-29.762h29.763Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2274.977-2915.933h29.762v29.762Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57.162 215.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1693.985 -318.165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-891.823 909.903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-877.107,925.818c.081,0,.121.032.121.1v2.753a.107.107,0,0,1-.121.121h-7.5a8.013,8.013,0,0,1-5.323-1.6,5.52,5.52,0,0,1-1.9-4.461,6.051,6.051,0,0,1,.869-3.235,5.7,5.7,0,0,1,2.493-2.179,8.964,8.964,0,0,1,3.857-.766h.688v-1.207h3.718v10.479Zm-6.772,0v-6.3h-.652a3.72,3.72,0,0,0-2.6.833,3.089,3.089,0,0,0-.911,2.4,2.883,2.883,0,0,0,.893,2.27,3.745,3.745,0,0,0,2.572.8Zm-2.306-12.037a1.574,1.574,0,0,1-1.207-.477,1.822,1.822,0,0,1-.446-1.3,1.855,1.855,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.546,1.546,0,0,1,1.2.47,1.867,1.867,0,0,1,.435,1.316,1.814,1.814,0,0,1-.447,1.31A1.564,1.564,0,0,1-886.185,913.781Zm4.2,0a1.575,1.575,0,0,1-1.207-.477,1.825,1.825,0,0,1-.446-1.3,1.858,1.858,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.551,1.551,0,0,1,1.207.477,1.871,1.871,0,0,1,.435,1.31,1.807,1.807,0,0,1-.453,1.3A1.563,1.563,0,0,1-881.984,913.781Z",
    transform: "translate(891.823 -910.002)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-867.282,926.109a4.9,4.9,0,0,1-1.2-3.26,5.464,5.464,0,0,1,1.907-4.389,7.945,7.945,0,0,1,5.312-1.624h4.406v12.241H-870.82a.107.107,0,0,1-.12-.121v-2.753c0-.064.04-.1.12-.1Zm6.748,0v-6.3h-.652a3.725,3.725,0,0,0-2.584.827,3.076,3.076,0,0,0-.918,2.409,2.894,2.894,0,0,0,.887,2.27,3.718,3.718,0,0,0,2.565.8Zm-.99-11.4a1.593,1.593,0,0,1-1.22-.477,1.825,1.825,0,0,1-.446-1.3,1.857,1.857,0,0,1,.44-1.31,1.587,1.587,0,0,1,1.226-.477,1.551,1.551,0,0,1,1.189.471,1.851,1.851,0,0,1,.441,1.316,1.807,1.807,0,0,1-.453,1.3A1.55,1.55,0,0,1-861.523,914.713Z",
    transform: "translate(885.282 -910.294)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-838.288,925.718c.08,0,.121.032.121.1v2.753a.107.107,0,0,1-.121.121h-6.773V909.9h3.682v15.815Z",
    transform: "translate(877.177 -909.903)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-835.606,929.079a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1h2.91v-9.272H-829v4.334q2.258-4.575,6.7-4.575a6.078,6.078,0,0,1,4.575,1.6,6.888,6.888,0,0,1,1.545,4.943v5.94Zm15.743-2.97v-3.043a3.681,3.681,0,0,0-.827-2.65,3.416,3.416,0,0,0-2.554-.852q-3.332,0-5.759,4.612v1.932Zm-3.972-11.4a1.593,1.593,0,0,1-1.22-.477,1.825,1.825,0,0,1-.446-1.3,1.854,1.854,0,0,1,.441-1.31,1.584,1.584,0,0,1,1.225-.477,1.55,1.55,0,0,1,1.189.471,1.851,1.851,0,0,1,.441,1.316,1.81,1.81,0,0,1-.453,1.3A1.552,1.552,0,0,1-823.835,914.713Z",
    transform: "translate(874.253 -910.294)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-803.413,934.724l1.413-.229a2.155,2.155,0,0,1-.809-.67,1.657,1.657,0,0,1-.314-1.008,2.01,2.01,0,0,1,.736-1.642,3.049,3.049,0,0,1,1.992-.6,4.164,4.164,0,0,1,2.029.446l-.5,1.256a3.113,3.113,0,0,0-1.34-.326,1.169,1.169,0,0,0-.857.32,1.168,1.168,0,0,0-.326.875,1.19,1.19,0,0,0,.736,1.11l.447-.072q1.207-.194,2-.253v1.437q-.882.06-2.915.3t-2.3.314Zm7.569-9.006c.081,0,.121.032.121.1v2.753a.107.107,0,0,1-.121.121h-6.772V909.9h3.682v15.815Z",
    transform: "translate(864.132 -909.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-792.8,931.672a.107.107,0,0,1-.121-.121V928.8c0-.064.041-.1.121-.1h3.091v-9.272h3.682v12.241Zm4.72,6.181a1.593,1.593,0,0,1-1.22-.477,1.825,1.825,0,0,1-.446-1.3,1.854,1.854,0,0,1,.441-1.31,1.584,1.584,0,0,1,1.225-.477,1.55,1.55,0,0,1,1.189.471,1.851,1.851,0,0,1,.441,1.316,1.809,1.809,0,0,1-.453,1.3A1.552,1.552,0,0,1-788.078,937.853Z",
    transform: "translate(860.845 -912.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-756.282,931.672a6.162,6.162,0,0,1-2.264-.374,5.185,5.185,0,0,1-1.817-1.279,6.535,6.535,0,0,1-2.173,1.237,7.746,7.746,0,0,1-2.523.417h-2.282a2.191,2.191,0,0,0-1.557.44,2,2,0,0,0-.447,1.467v6h-3.682V932.36a3.734,3.734,0,0,1,.845-2.571,3.358,3.358,0,0,1,2.39-1.062,8.718,8.718,0,0,1-.664-3.428,8.354,8.354,0,0,1,.374-2.354,8.57,8.57,0,0,1,.893-2.1,10.423,10.423,0,0,1,2.463-1.032,9.065,9.065,0,0,1,2.426-.38,6.52,6.52,0,0,1,3.066.718,5.226,5.226,0,0,1,2.149,2.052,6.018,6.018,0,0,1,.773,3.072,6.854,6.854,0,0,1-.471,2.511,2.453,2.453,0,0,0,1.026.712,4.484,4.484,0,0,0,1.473.205h.121c.08,0,.121.032.121.1v2.753a.107.107,0,0,1-.121.121Zm-10.756-5.856a8.924,8.924,0,0,0,.567,2.886h.942a3.4,3.4,0,0,0,2.493-1,3.3,3.3,0,0,0,1.008-2.427,3.166,3.166,0,0,0-.646-2.113,2.117,2.117,0,0,0-1.7-.76,4.623,4.623,0,0,0-2.306.688A10.159,10.159,0,0,0-767.039,925.817Z",
    transform: "translate(854.615 -912.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-745.34,926.109a4.9,4.9,0,0,1-1.2-3.26,5.466,5.466,0,0,1,1.907-4.389,7.947,7.947,0,0,1,5.312-1.624h4.406v12.241h-13.968a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1Zm3.622-11.4a1.576,1.576,0,0,1-1.207-.477,1.822,1.822,0,0,1-.447-1.3,1.854,1.854,0,0,1,.441-1.31,1.571,1.571,0,0,1,1.214-.477,1.546,1.546,0,0,1,1.2.471,1.868,1.868,0,0,1,.435,1.316,1.812,1.812,0,0,1-.447,1.31A1.565,1.565,0,0,1-741.718,914.713Zm3.126,11.4v-6.3h-.652a3.725,3.725,0,0,0-2.584.827,3.078,3.078,0,0,0-.918,2.409,2.894,2.894,0,0,0,.887,2.27,3.721,3.721,0,0,0,2.566.8Zm1.075-11.4a1.577,1.577,0,0,1-1.207-.477,1.822,1.822,0,0,1-.446-1.3,1.854,1.854,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.551,1.551,0,0,1,1.207.477,1.874,1.874,0,0,1,.434,1.31,1.807,1.807,0,0,1-.453,1.3A1.565,1.565,0,0,1-737.517,914.713Z",
    transform: "translate(847.089 -910.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-868.583,976.139a6.1,6.1,0,0,1-2.264-.374,5.677,5.677,0,0,1-1.938-1.437q-.265-.277-1.255-1.665a12.634,12.634,0,0,0-1.835-2.179,2.018,2.018,0,0,0-1.255-.549,1.93,1.93,0,0,0-1,.411,4.247,4.247,0,0,0-1.014.953,1.657,1.657,0,0,0-.411.93,1.137,1.137,0,0,0,.428.881,4.1,4.1,0,0,0,1.359.688,11.185,11.185,0,0,1,2.336,1.014,3.282,3.282,0,0,1,1.135,1.172,3.285,3.285,0,0,1,.38,1.617,3.729,3.729,0,0,1-1.768,3.332,9.926,9.926,0,0,1-5.33,1.147h-5.831a4.727,4.727,0,0,1-2.56-.718,4.814,4.814,0,0,1-1.78-2.01,6.51,6.51,0,0,1-.634-2.909,14.88,14.88,0,0,1,.8-4.781h3.284a10.692,10.692,0,0,0-.416,1.944,21.136,21.136,0,0,0-.1,2.294,3.257,3.257,0,0,0,.417,1.6,3.162,3.162,0,0,0,1.1,1.183,2.66,2.66,0,0,0,1.424.429h4.274a8.235,8.235,0,0,0,2.734-.3,1.041,1.041,0,0,0,.731-1.014.869.869,0,0,0-.4-.718,4.1,4.1,0,0,0-1.3-.537,5.894,5.894,0,0,1-2.885-1.412,3.382,3.382,0,0,1-.808-2.378,4.958,4.958,0,0,1,.935-2.711,8.306,8.306,0,0,1,2.42-2.39,5.232,5.232,0,0,1,2.849-.972,3.508,3.508,0,0,1,1.472.308,4.623,4.623,0,0,1,1.31.93,22.254,22.254,0,0,1,2.071,2.674,8.87,8.87,0,0,0,1.829,2.107,2.606,2.606,0,0,0,1.5.477h.12c.089,0,.133.032.133.1v2.753c0,.08-.045.121-.133.121Zm-16.346,12.048a1.575,1.575,0,0,1-1.207-.477,1.822,1.822,0,0,1-.446-1.3,1.857,1.857,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.546,1.546,0,0,1,1.195.47,1.867,1.867,0,0,1,.435,1.316,1.815,1.815,0,0,1-.446,1.31A1.567,1.567,0,0,1-884.93,988.187Zm4.2,0a1.575,1.575,0,0,1-1.207-.477,1.825,1.825,0,0,1-.446-1.3,1.857,1.857,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.551,1.551,0,0,1,1.207.477,1.871,1.871,0,0,1,.435,1.31,1.807,1.807,0,0,1-.453,1.3A1.562,1.562,0,0,1-880.729,988.187Z",
    transform: "translate(891.823 -927.684)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-841.158,969.31c.08,0,.121.032.121.1v2.753a.107.107,0,0,1-.121.121h-17.058a.107.107,0,0,1-.121-.121v-2.753c0-.064.04-.1.121-.1h3.537a4.9,4.9,0,0,1-1.2-3.259,5.466,5.466,0,0,1,1.907-4.389,7.947,7.947,0,0,1,5.312-1.624h4.406v9.272Zm-6.773,0v-6.3h-.652a3.725,3.725,0,0,0-2.584.827,3.078,3.078,0,0,0-.917,2.409,2.892,2.892,0,0,0,.887,2.27,3.718,3.718,0,0,0,2.565.8Zm-.99-11.4a1.588,1.588,0,0,1-1.219-.477,1.822,1.822,0,0,1-.447-1.3,1.855,1.855,0,0,1,.441-1.31,1.585,1.585,0,0,1,1.225-.477,1.549,1.549,0,0,1,1.189.47,1.851,1.851,0,0,1,.441,1.316,1.81,1.81,0,0,1-.453,1.3A1.55,1.55,0,0,1-848.92,957.913Z",
    transform: "translate(881.335 -923.825)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-833.73,972.279a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1h3.827v-9.272h3.683v9.272h3.718c.08,0,.121.032.121.1v2.753a.107.107,0,0,1-.121.121Zm3.356-14.366a1.575,1.575,0,0,1-1.207-.477,1.825,1.825,0,0,1-.446-1.3,1.858,1.858,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.546,1.546,0,0,1,1.2.47,1.867,1.867,0,0,1,.435,1.316,1.815,1.815,0,0,1-.446,1.31A1.564,1.564,0,0,1-830.374,957.913Zm4.2,0a1.575,1.575,0,0,1-1.207-.477,1.825,1.825,0,0,1-.446-1.3,1.858,1.858,0,0,1,.44-1.31,1.571,1.571,0,0,1,1.214-.477,1.551,1.551,0,0,1,1.207.477,1.872,1.872,0,0,1,.435,1.31,1.81,1.81,0,0,1-.453,1.3A1.565,1.565,0,0,1-826.173,957.913Z",
    transform: "translate(873.666 -923.825)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-817.751,972.279a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1h9.984a6.774,6.774,0,0,1-1.509-3.538,4.686,4.686,0,0,0-1-2.336,2.651,2.651,0,0,0-1.974-.67,5.913,5.913,0,0,0-1.63.217,8.019,8.019,0,0,0-1.654.712l-1.111-2.716a10.787,10.787,0,0,1,5.167-1.183,5.98,5.98,0,0,1,3.852,1.111,5.747,5.747,0,0,1,1.81,3.659q.641,3.682,1.727,4.744h1.606c.089,0,.133.032.133.1v2.753c0,.08-.044.121-.133.121Zm6.531-14.366a1.589,1.589,0,0,1-1.219-.477,1.822,1.822,0,0,1-.446-1.3,1.858,1.858,0,0,1,.44-1.31,1.586,1.586,0,0,1,1.225-.477,1.551,1.551,0,0,1,1.19.47,1.85,1.85,0,0,1,.441,1.316,1.807,1.807,0,0,1-.453,1.3A1.548,1.548,0,0,1-811.22,957.913Z",
    transform: "translate(868.661 -923.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-791.4,976.131c.089,0,.133.032.133.1v2.753c0,.08-.045.121-.133.121h-4.467a.107.107,0,0,1-.12-.121v-2.753c0-.064.04-.1.12-.1Z",
    transform: "translate(861.806 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-785.247,976.131c.089,0,.133.032.133.1v2.753c0,.08-.044.121-.133.121h-4.467a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1Z",
    transform: "translate(859.879 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-779.1,976.131c.089,0,.133.032.133.1v2.753c0,.08-.044.121-.133.121h-4.467a.107.107,0,0,1-.121-.121v-2.753c0-.064.04-.1.121-.1Z",
    transform: "translate(857.952 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-772.943,976.131c.089,0,.133.032.133.1v2.753c0,.08-.045.121-.133.121h-4.466a.107.107,0,0,1-.121-.121v-2.753c0-.064.04-.1.121-.1Z",
    transform: "translate(856.025 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-766.79,976.131c.089,0,.133.032.133.1v2.753c0,.08-.044.121-.133.121h-4.467a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1Z",
    transform: "translate(854.098 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-760.638,976.131c.089,0,.133.032.133.1v2.753c0,.08-.044.121-.133.121h-4.467a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1Z",
    transform: "translate(852.171 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-754.486,976.131c.089,0,.133.032.133.1v2.753c0,.08-.045.121-.133.121h-4.466a.107.107,0,0,1-.121-.121v-2.753c0-.064.04-.1.121-.1Z",
    transform: "translate(850.244 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-748.333,976.131c.089,0,.133.032.133.1v2.753c0,.08-.044.121-.133.121H-752.8a.107.107,0,0,1-.121-.121v-2.753c0-.064.041-.1.121-.1Z",
    transform: "translate(848.317 -930.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-743.859,971.9a8.419,8.419,0,0,1-.664-3.4,8.333,8.333,0,0,1,.362-2.318,9.224,9.224,0,0,1,.893-2.137,10.6,10.6,0,0,1,2.541-1.051,9.265,9.265,0,0,1,2.36-.362,6.509,6.509,0,0,1,3.072.725,5.206,5.206,0,0,1,2.143,2.046,6.053,6.053,0,0,1,.76,3.073,6.318,6.318,0,0,1-.875,3.332,6.024,6.024,0,0,1-2.433,2.257,7.346,7.346,0,0,1-3.441.809h-7.509a.107.107,0,0,1-.121-.121V972c0-.064.04-.1.121-.1Zm2.753-2.885a8.922,8.922,0,0,0,.567,2.885h.929a3.412,3.412,0,0,0,2.505-1,3.3,3.3,0,0,0,1.008-2.426,3.2,3.2,0,0,0-.64-2.095,2.092,2.092,0,0,0-1.7-.779,4.622,4.622,0,0,0-2.306.688A10.141,10.141,0,0,0-741.106,969.017Z",
    transform: "translate(846.39 -926.418)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.721 14.705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.678,457.2c-8.708-38.461-58.417-57.207-75.591-63.255-18.867-6.652-45.717-8.224-63.013-12.095-9.918-2.177-24.31-7.62-29.148-13.425s-1.935-59.626-1.935-59.626,8.95-13.909,13.788-26.245c4.838-12.216,10.159-45.838,10.159-45.838s9.918,0,13.425-17.416c3.749-18.988,9.676-26.366,8.95-40.517-.726-13.909-8.345-13.546-8.345-13.546s7.378-20.2,8.224-62.045C346.281,53.483,307.337,4.5,236.825,4.5c-71.479,0-109.577,48.983-108.488,98.692.968,41.847,8.1,62.045,8.1,62.045s-7.62-.363-8.345,13.546c-.726,14.151,5.2,21.528,8.95,40.517,3.386,17.416,13.425,17.416,13.425,17.416s5.322,33.623,10.159,45.838c4.838,12.336,13.788,26.245,13.788,26.245s2.9,53.821-1.935,59.626-19.23,11.248-29.148,13.425c-17.3,3.87-44.145,5.443-63.013,12.095C63.148,399.992,13.439,418.738,4.731,457.2a9.669,9.669,0,0,0,9.555,11.732H459.244A9.648,9.648,0,0,0,468.678,457.2Z",
    transform: "translate(299.963 424.589) rotate(1)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.476,0C36.12,0,17.753,12.628,3.333,35.15a9.822,9.822,0,0,0,1.84,12.694L20.5,60.475a8.072,8.072,0,0,0,11.813-1.6c8.9-12.118,15.5-19.095,29.4-19.095,10.929,0,24.447,7.645,24.447,19.165,0,8.709-6.614,13.181-17.405,19.757C56.17,86.37,39.517,95.914,39.517,119.789v3.78c0,5.118,3.817,9.268,8.526,9.268H73.789c4.709,0,8.526-4.149,8.526-9.268V121.34c0-16.551,44.5-17.24,44.5-62.027C126.818,25.585,94.631,0,64.476,0Zm-3.56,144.212c-13.569,0-24.609,12-24.609,26.749s11.04,26.749,24.609,26.749,24.609-12,24.609-26.749S74.485,144.212,60.916,144.212Z",
    transform: "matrix(1, 0.017, -0.017, 1, 480.276, 523.969)",
    fill: "#bef2ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.058 891.778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.67, -487.78)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319.017,
    height: 89.294,
    rx: 44.647,
    transform: "translate(10.67 487.78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(94.479 39)",
    fill: "#1ca4c7",
    fontSize: 36,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.208 67.017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-799.639,1326.8h-.022l-1.259.679-.19-.746,1.583-.847h.836v7.244h-.948Z",
    transform: "translate(801.11 -1324.664)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-793.369,1333.069v-.6l.769-.747c1.85-1.76,2.686-2.7,2.7-3.789a1.292,1.292,0,0,0-1.438-1.415,2.469,2.469,0,0,0-1.538.613l-.312-.691a3.182,3.182,0,0,1,2.05-.736,2.039,2.039,0,0,1,2.218,2.107c0,1.338-.97,2.418-2.5,3.889l-.579.535v.023h3.254v.813Z",
    transform: "translate(798.43 -1324.599)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-782.125,1331.805v.724h-2.753v-.724Z",
    transform: "translate(795.491 -1326.712)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-774.627,1329.369c0,2.462-.913,3.822-2.519,3.822-1.416,0-2.373-1.326-2.4-3.722,0-2.43,1.047-3.767,2.519-3.767C-775.5,1325.7-774.627,1327.062-774.627,1329.369Zm-3.934.11c0,1.884.58,2.953,1.471,2.953,1,0,1.483-1.17,1.483-3.02,0-1.783-.458-2.954-1.471-2.954C-777.937,1326.46-778.561,1327.508-778.561,1329.48Z",
    transform: "translate(793.644 -1324.599)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-766.335,1326.714H-769.1l-.279,1.862a3.873,3.873,0,0,1,.591-.044,3.062,3.062,0,0,1,1.56.39,2.066,2.066,0,0,1,1.036,1.861,2.513,2.513,0,0,1-2.7,2.474,3.552,3.552,0,0,1-1.805-.445l.245-.747a3.248,3.248,0,0,0,1.549.4,1.6,1.6,0,0,0,1.716-1.571c-.011-.936-.635-1.6-2.084-1.6a7.389,7.389,0,0,0-1,.078l.468-3.477h3.465Z",
    transform: "translate(790.581 -1324.664)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-759.4,1331.805v.724h-2.753v-.724Z",
    transform: "translate(787.624 -1326.712)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-754.183,1326.8h-.022l-1.259.679-.19-.746,1.582-.847h.836v7.244h-.947Z",
    transform: "translate(785.375 -1324.664)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-747.368,1332.378a4.1,4.1,0,0,0,.791-.033,2.731,2.731,0,0,0,1.516-.7,3.177,3.177,0,0,0,.959-1.927h-.033a2.125,2.125,0,0,1-1.705.779,2.1,2.1,0,0,1-2.139-2.217,2.484,2.484,0,0,1,2.474-2.575c1.482,0,2.4,1.2,2.4,3.054a4.575,4.575,0,0,1-1.248,3.4,3.62,3.62,0,0,1-2.107.97,4.576,4.576,0,0,1-.9.056Zm.356-4.168a1.394,1.394,0,0,0,1.393,1.539,1.619,1.619,0,0,0,1.426-.759.639.639,0,0,0,.09-.356c0-1.238-.457-2.184-1.482-2.184C-746.421,1326.449-747.012,1327.185-747.012,1328.209Z",
    transform: "translate(782.719 -1324.599)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-734.406,1329.369c0,2.462-.913,3.822-2.519,3.822-1.415,0-2.373-1.326-2.4-3.722,0-2.43,1.047-3.767,2.519-3.767C-735.275,1325.7-734.406,1327.062-734.406,1329.369Zm-3.933.11c0,1.884.579,2.953,1.471,2.953,1,0,1.482-1.17,1.482-3.02,0-1.783-.457-2.954-1.471-2.954C-737.716,1326.46-738.339,1327.508-738.339,1329.48Z",
    transform: "translate(779.721 -1324.599)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-730.419,1333.069v-.6l.768-.747c1.85-1.76,2.686-2.7,2.7-3.789a1.292,1.292,0,0,0-1.437-1.415,2.465,2.465,0,0,0-1.538.613l-.313-.691a3.181,3.181,0,0,1,2.05-.736,2.039,2.039,0,0,1,2.218,2.107c0,1.338-.97,2.418-2.5,3.889l-.579.535v.023h3.254v.813Z",
    transform: "translate(776.64 -1324.599)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-711.058,1333.29a2.074,2.074,0,0,1-.776,1.718,3.4,3.4,0,0,1-2.169.618h-1.323a2.13,2.13,0,0,1-1.546-.523,1.958,1.958,0,0,1-.539-1.475,4.323,4.323,0,0,1,.277-1.508h.833a7.032,7.032,0,0,0-.163,1.431,1.245,1.245,0,0,0,.3.879,1.045,1.045,0,0,0,.806.324H-714q1.955,0,1.954-1.476v-1.437q0-3.14,2.907-3.141h1.35v4.535h1.393v.871h-2.384v-4.54h-.289q-1.987,0-1.986,2.309Zm-3.691,2.934q.583,0,.583.626t-.583.62q-.578,0-.577-.62T-714.749,1336.224Zm1.7,0q.582,0,.583.626t-.583.62q-.578,0-.577-.62T-713.045,1336.224Z",
    transform: "translate(772.137 -1325.637)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-700.9,1332.032h1.748a2.431,2.431,0,0,1-.577-1.682,2.72,2.72,0,0,1,.822-2.077,3.12,3.12,0,0,1,2.232-.776h1.459v5.406H-700.9Zm4.257-3.669a2.159,2.159,0,0,0-1.543.522,1.905,1.905,0,0,0-.553,1.454q0,1.692,1.524,1.693h1.051v-3.669Zm-.392-3.14q.583,0,.583.626t-.583.621q-.577,0-.577-.621T-697.037,1325.222Z",
    transform: "translate(766.422 -1324.433)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-682.982,1332.9a2.02,2.02,0,0,1-1.519-.583,2.169,2.169,0,0,1-.566-1.579,5.09,5.09,0,0,1,.277-1.676h.893a7.923,7.923,0,0,0-.169,1.595,1.613,1.613,0,0,0,.286.985.9.9,0,0,0,.765.386h4V1327.5h.947v3.468a1.018,1.018,0,0,0,.3.778,1.117,1.117,0,0,0,.8.289h.179v.871h-.033a1.264,1.264,0,0,1-1.251-.637v.637Zm.767-7.681q.583,0,.583.626t-.583.621q-.577,0-.577-.621T-682.215,1325.222Zm1.71,0q.577,0,.577.626t-.577.621q-.583,0-.583-.621T-680.505,1325.222Z",
    transform: "translate(760.941 -1324.433)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-672.737,1332.032h1.748a2.432,2.432,0,0,1-.577-1.682,2.7,2.7,0,0,1,.83-2.09,3.16,3.16,0,0,1,2.224-.762h1.459v4.535h1.236v.871h-6.919Zm4.257-3.669a2.148,2.148,0,0,0-1.546.526,1.925,1.925,0,0,0-.55,1.461q0,1.682,1.524,1.682H-668v-3.669Zm-.392-3.14q.583,0,.583.626t-.583.621q-.577,0-.577-.621T-668.872,1325.222Z",
    transform: "translate(756.672 -1324.433)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-662.488,1332.032h1.524V1327.5h.991v3.468a1.024,1.024,0,0,0,.3.778,1.115,1.115,0,0,0,.8.289h.4v.871h-.256a1.266,1.266,0,0,1-1.252-.637v.637h-2.515Zm1.077-6.81q.583,0,.583.626t-.583.621q-.577,0-.577-.621T-661.411,1325.222Zm1.709,0q.578,0,.577.626t-.577.621q-.583,0-.583-.621T-659.7,1325.222Z",
    transform: "translate(753.125 -1324.433)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-651.843,1332.032a4.318,4.318,0,0,1-.7-2.041,3.057,3.057,0,0,0-.477-1.361,1.127,1.127,0,0,0-.928-.377,3.564,3.564,0,0,0-1.617.447l-.386-.768a3.643,3.643,0,0,1,2.014-.55,2.138,2.138,0,0,1,1.516.515,3.155,3.155,0,0,1,.76,1.837,4.187,4.187,0,0,0,.838,2.319v.849h-5.851v-.871Zm-2.172-6.81q.577,0,.577.626t-.577.621q-.577,0-.577-.621T-654.015,1325.222Z",
    transform: "translate(751.113 -1324.433)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-644.173,1335.026a13.563,13.563,0,0,0-2.156.267v-.512l.528-.077a.823.823,0,0,1-.392-.7.917.917,0,0,1,.316-.743,1.241,1.241,0,0,1,.823-.264,1.638,1.638,0,0,1,.735.169l-.169.5a1.3,1.3,0,0,0-.555-.131.508.508,0,0,0-.583.566.551.551,0,0,0,.338.522q.974-.135,1.115-.141Zm-.632-2.542h-.991v-8.47h.991Z",
    transform: "translate(747.531 -1324.015)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-633.047,1326.714h-2.763l-.279,1.862a3.879,3.879,0,0,1,.591-.044,3.061,3.061,0,0,1,1.56.39,2.065,2.065,0,0,1,1.036,1.861,2.513,2.513,0,0,1-2.7,2.474,3.554,3.554,0,0,1-1.805-.445l.245-.747a3.248,3.248,0,0,0,1.549.4,1.6,1.6,0,0,0,1.716-1.571c-.011-.936-.635-1.6-2.084-1.6a7.389,7.389,0,0,0-1,.078l.468-3.477h3.465Z",
    transform: "translate(744.442 -1324.664)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-624.3,1326.714h-2.764l-.279,1.862a3.87,3.87,0,0,1,.59-.044,3.064,3.064,0,0,1,1.561.39,2.065,2.065,0,0,1,1.036,1.861,2.513,2.513,0,0,1-2.7,2.474,3.551,3.551,0,0,1-1.805-.445l.245-.747a3.249,3.249,0,0,0,1.549.4,1.6,1.6,0,0,0,1.716-1.571c-.011-.936-.636-1.6-2.084-1.6a7.377,7.377,0,0,0-1,.078l.468-3.477h3.465Z",
    transform: "translate(741.414 -1324.664)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-609.271,1331.622a1.018,1.018,0,0,0,.3.778,1.117,1.117,0,0,0,.8.289h.18v.871h-.033a1.265,1.265,0,0,1-1.252-.637v.593q0,2.723-2.776,2.721h-.8a2.034,2.034,0,0,1-1.63-.718,2.939,2.939,0,0,1-.613-1.971,6.471,6.471,0,0,1,.457-2.466h.926a6.721,6.721,0,0,0-.381,2.4,2.246,2.246,0,0,0,.376,1.39,1.273,1.273,0,0,0,1.077.492h.545q1.872,0,1.872-1.785v-5.427h.947Zm-2.929-4.5c.384,0,.577.208.577.626s-.192.62-.577.62-.577-.207-.577-.62S-612.584,1327.12-612.2,1327.12Z",
    transform: "translate(736.717 -1325.09)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-604.566,1334.107v-.871h1.649v-3.669h.947V1332a1.214,1.214,0,0,0,.34.89,1.171,1.171,0,0,0,.874.346h.692v-3.669h.947V1332a1.214,1.214,0,0,0,.34.89,1.171,1.171,0,0,0,.873.346h.691V1328.7h.947v3.468a1.019,1.019,0,0,0,.3.778,1.117,1.117,0,0,0,.8.289h.18v.871h-.033a1.266,1.266,0,0,1-1.252-.637v.637h-1.606a1.246,1.246,0,0,1-1.246-.637v.637h-1.606a1.247,1.247,0,0,1-1.247-.637v.637Z",
    transform: "translate(733.074 -1325.637)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-590.247,1331.614h1.524v-7.6h.991v8.47h-2.515Z",
    transform: "translate(728.118 -1324.015)",
    fill: "#1ca4c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-582.512,1332.485h-.991v-8.47h.991Z",
    transform: "translate(725.783 -1324.015)",
    fill: "#1ca4c7"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 14.705,
    cy: 14.705,
    r: 14.705,
    transform: "translate(166.387 901.632)",
    fill: "#6c0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.9398be1fa22cc69cb5118fce11ce24a9.svg";
export { ForwardRef as ReactComponent };